import { render, staticRenderFns } from "./RiskKeyword.vue?vue&type=template&id=271029e8&scoped=true&"
import script from "./RiskKeyword.vue?vue&type=script&lang=js&"
export * from "./RiskKeyword.vue?vue&type=script&lang=js&"
import style0 from "./RiskKeyword.vue?vue&type=style&index=0&id=271029e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "271029e8",
  null
  
)

export default component.exports